import { render, staticRenderFns } from "./TheorySessions.vue?vue&type=template&id=22f67cd2&"
import script from "./TheorySessions.vue?vue&type=script&lang=ts&"
export * from "./TheorySessions.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports